var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "container", attrs: { fluid: "" } },
    [
      _c("SwitchesTop", {
        attrs: {
          switchState: _vm.switchState,
          caregoryList: _vm.caregoryList,
          defaultSelected: _vm.defaultSelected
        },
        on: {
          changeSwitchVisualizacao: _vm.changeSwitchVisualizacao,
          switchsMoedas: _vm.switchsMoedas,
          changeKey: _vm.changeKey,
          onChangeEstrategy: _vm.onChange,
          "date-range-changed": _vm.changeRange
        }
      }),
      _c("div", { staticClass: "switch-view-all" }, [
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.showAll,
                expression: "showAll"
              }
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.showAll)
                ? _vm._i(_vm.showAll, null) > -1
                : _vm.showAll
            },
            on: {
              change: function($event) {
                var $$a = _vm.showAll,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.showAll = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.showAll = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.showAll = $$c
                }
              }
            }
          }),
          _vm._v(" Exibir ativos encerrados ")
        ])
      ]),
      _c("CardTopInformacoes", {
        staticClass: "cards-top",
        attrs: {
          switchVisualizacao: _vm.switchVisualizacao,
          selectedType: _vm.selectedType,
          indice: _vm.indice,
          monthLabel: _vm.monthLabel,
          timeLabel: _vm.timeLabel
        }
      }),
      _c("BarraDeCarteira", {
        attrs: {
          switchVisualizacao: _vm.switchVisualizacao,
          wallet: _vm.wallet,
          evolucao: _vm.evolucao,
          bound: (_vm.evolucao && _vm.evolucao.bound) || false
        }
      }),
      !_vm.loading
        ? _c(
            "div",
            [
              _vm.selectedType == "porClasseEProduto"
                ? _c("AccordionGroupClasseEProduto", {
                    attrs: {
                      switchVisualizacao: _vm.switchVisualizacao,
                      telaMobile: _vm.telaMobile,
                      dessertsCdbRdb: _vm.dessertsCdbRdb,
                      dessertsCriCra: _vm.dessertsCriCra,
                      dessertsDebentures: _vm.dessertsDebentures,
                      dessertsLciLca: _vm.dessertsLciLca,
                      dessertsTitulosPublicos: _vm.dessertsTitulosPublicos,
                      dessertsAcoes: _vm.dessertsAcoes,
                      dessertsFundosImobiliarios:
                        _vm.dessertsFundosImobiliarios,
                      dessertsFundosInvestimento:
                        _vm.dessertsFundosInvestimento,
                      dessertsPrevidencia: _vm.dessertsPrevidencia,
                      dessertsOutros: _vm.dessertsOutros,
                      evolucao: _vm.evolucao,
                      showAll: _vm.showAll,
                      bound: (_vm.evolucao && _vm.evolucao.bound) || false
                    }
                  })
                : _vm._e(),
              _vm.selectedType == "porEstrategia"
                ? _c("AccordionGroupPorEstrategia", {
                    attrs: {
                      switchVisualizacao: _vm.switchVisualizacao,
                      telaMobile: _vm.telaMobile,
                      dessertsJurosPre: _vm.dessertsJurosPre,
                      dessertsJurosPosCdi: _vm.dessertsJurosPosCdi,
                      dessertsJurosPosInflacao: _vm.dessertsJurosPosInflacao,
                      dessertsLivre: _vm.dessertsLivre,
                      dessertsRendaVariavel: _vm.dessertsRendaVariavel,
                      dessertsCambio: _vm.dessertsCambio,
                      evolucao: _vm.evolucao,
                      showAll: _vm.showAll,
                      bound: (_vm.evolucao && _vm.evolucao.bound) || false
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }